export enum PlatformSync {
    NONE = 'NONE',
    ALL = 'ALL',
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
